/* eslint-disable max-lines */
// TODO: ir añadiendo características
import { useLanguage } from 'context/languageContext';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  DEFAULT_LANGUAGE,
  // EVENTS_CATEGORIES,
  PALMA_OFFICES_SECTIONS,
  POINTS_SALE_SECTIONS,
  RUTAS_GENERALES_MUL2,
} from 'utils/constants';
import { formatMarkers } from 'utils/utils';
import ErrorScreen from 'screens/errorScreen/ErrorScreen';
// import NavLoading from 'screens/homeScreen/components/navLoading/Loading';
import { useLocation } from 'react-router-dom';

/* SERVICES */
import { useLazyGetAgencyQuery, useLazyGetDataOriginQuery } from 'redux/services/agencyService';
import { useLazyGetAlertsQuery, useLazyGetMessagesPriorityQuery } from 'redux/services/alertsService';
import { useLazyGetCategoryQuery } from 'redux/services/categoryService';
import { useLazyGetEventCategoriesQuery } from 'redux/services/eventsService';
import { useLazyGetContactDataQuery } from 'redux/services/webService';
import {
  useLazyGetCategoryFavoritesQuery,
  useLazyGetFavoritesQuery,
} from 'redux/services/favoritesService';
import { useLazyGetLinesQuery } from 'redux/services/linesService';
import { useLazyGetFaqKeywordsQuery } from 'redux/services/webService';
import { useLazyGetPoisQuery } from 'redux/services/poisService';
import { useLazyGetStopsQuery } from 'redux/services/stopsService';
import { useLazyGetTransportModeQuery } from 'redux/services/transportmodeService';
import { useCreateUserAnonymousMutation } from 'redux/services/userService';
//import { useLazyGetPrimaryBannersQuery } from 'redux/services/webService';
import { useLazyGetFaresQuery } from 'redux/services/webService';
import { useLazyGetRoutesQuery } from 'redux/services/routesService';

/* SLICES */
import { updateAgencys, updateDataOrigin } from 'redux/slices/agencysSlice';
import { updateAlerts, updatePriorityMessage } from 'redux/slices/alertsSlice';
import { updateCategory } from 'redux/slices/categorySlice';
import { updateShowLoading } from 'redux/slices/contextualSlice';
import { /* updateEventsCategory, */ addEventsCategory } from 'redux/slices/eventsSlice';
import { updateContactData, updateFaqKeywordss } from 'redux/slices/webSlice';
import { updateCategoryFavorites, updateFavorites } from 'redux/slices/favoritesSlice';
import { updateLines } from 'redux/slices/linesSlice';
import { updatePoiCategoryIcons } from 'redux/slices/iconsSlice';
import { updatePois, updatePointsSalePois, updateEmtOfficePois } from 'redux/slices/poisSlices';
import { updateStops } from 'redux/slices/stopsSlice';
import { updateTransportMode } from 'redux/slices/transportmodeSlice';
import {
  tokenDeviceUpdate,
  updateUserData,
  userSliceFingerprint,
  userState,
} from 'redux/slices/userSlice';
//import { updatePrimaryBanners } from 'redux/slices/webSlice';
import { updateFares } from 'redux/slices/webSlice';
import { updateMenuFooter } from 'redux/slices/routesSlice';
import StopQrSkeleton from 'screens/stopQr/StopQrSkeleton';
import EmtNewDetailSkeleton from 'screens/emtNewDetail/component/emtNewDetailSkeleton/EmtNewDetailSkeleton';
import { messaging } from '../../firebase';
import { getToken } from 'firebase/messaging';
import MainSkeleton from 'components/commons/skeletons/mainSkeleton/MainSkeleton';
import IconPresenter from 'hooks/IconPresenter';

export default function Precarga({ callback }) {
  const location = useLocation();
  const dispatch = useDispatch<any>();
  const currentLanguage = useLanguage();
  const userAccountInformation = useSelector(userState);

  const iconPresenter = IconPresenter();

  const [loading, setLoading] = useState(true) as any;
  const [linesAPI, setLinesAPI] = useState(null) as any;
  const [generalError, setGeneralError] = useState(null) as any;
  const [favoritesAPI, setFavoritesAPI] = useState(null) as any;
  const [dataOriginAPI, setDataOriginAPI] = useState(null) as any;
  const [stopsAPI, setStopsAPI] = useState(null) as any;
  const [poisAPI, setPoisAPI] = useState(null) as any;
  const [poisCategoriesAPI, setPoisCategoriesAPI] = useState(null) as any;
  const [agencyAPI, setAgencyAPI] = useState(null) as any;
  const [tranportModeAPI, setTranportModeAPI] = useState(null) as any;
  const [warningsAPI, setWarningsAPI] = useState(null) as any;
  const [contactDataAPI, setContactDataAPI] = useState(null) as any;
  const [eventsCategoriesAPI, setEventsCategoriesAPI] = useState(null) as any;
  const [categoryFavoritesAPI, setCategoryFavoritesAPI] = useState(null) as any;
  //const [primaryBannersAPI, setPrimaryBannersAPI] = useState(null) as any;
  const [faresAPI, setFaresAPI] = useState(null) as any;
  const [menuFooterAPI, setFooterMenuAPI] = useState(null) as any;

  const [GetDataOrigin] = useLazyGetDataOriginQuery();
  const [GetTransportMode] = useLazyGetTransportModeQuery();
  const [GetStops] = useLazyGetStopsQuery();
  const [GetPois] = useLazyGetPoisQuery();
  const [GetPoisCategories] = useLazyGetCategoryQuery();
  const [GetLines] = useLazyGetLinesQuery();
  const [GetAgency] = useLazyGetAgencyQuery();
  const [createUserAnonymous] = useCreateUserAnonymousMutation();
  const [GetFavorites] = useLazyGetFavoritesQuery();
  const [GetCategoryFavorites] = useLazyGetCategoryFavoritesQuery();
  const [GetAlerts] = useLazyGetAlertsQuery();
  const [GetContactData] = useLazyGetContactDataQuery();
  const [GetEventsCategories] = useLazyGetEventCategoriesQuery();
  const [GetFares] = useLazyGetFaresQuery();
  //const [GetPrimaryBanners] = useLazyGetPrimaryBannersQuery();
  const [GetRoutes] = useLazyGetRoutesQuery();
  const [GetFaqKeywords] = useLazyGetFaqKeywordsQuery();
  const [getPriorityMessages] = useLazyGetMessagesPriorityQuery();

  //`${location.pathname.split('/')[2]}/`
  const getLoadingPage = (_url) => {
    const p1 = _url.split('/')[1];
    const p2 = _url.split('/')[2];
    const url = `${p1}/${p2}/`;

    if (p1 === 'p') return <StopQrSkeleton />;
    switch (url) {
      case `${currentLanguage}/${RUTAS_GENERALES_MUL2.paradas[currentLanguage]}`:
        return <StopQrSkeleton />;
      case `${currentLanguage}/${RUTAS_GENERALES_MUL2.lines[currentLanguage]}`:
        return <StopQrSkeleton />;
      case `${currentLanguage}/${RUTAS_GENERALES_MUL2.planner[currentLanguage]}`:
        return <StopQrSkeleton />;
      case `${currentLanguage}/${RUTAS_GENERALES_MUL2.emtNewDetail[currentLanguage]}`:
        return <div style={{maxWidth:'1280px', marginLeft:'auto', marginRight:'auto'}}><EmtNewDetailSkeleton /></div>;
      default:
        return <MainSkeleton/>;
    }
  };

  const precarga = async () => {
    setLoading(true);
    try {

      //Obtenemos los iconos de las categorías de los favoritos

       /* GetPrimaryBanners({ language: currentLanguage })
        .then(async (banners) => {
          if (banners.isSuccess) {
            dispatch(updatePrimaryBanners(banners.data));
            setPrimaryBannersAPI(banners.data);
          } else {
            if (banners.error) {
              if ('status' in banners.error) {
                if (banners.error.status === 401) {
                  const tokenDevice = await dispatch(userSliceFingerprint()).unwrap();

                  createUserAnonymousCall(tokenDevice);
                }
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
          setGeneralError(true);
        }); */

       GetRoutes({ language: currentLanguage, type: 2 })
        .then(async (menu) => {
          if (menu.isSuccess) {
            dispatch(updateMenuFooter(menu.data));
            setFooterMenuAPI(menu.data);
          } else {
            if (menu.error) {
              if ('status' in menu.error) {
                if (menu.error.status === 401) {
                  const tokenDevice = await dispatch(userSliceFingerprint()).unwrap();

                  createUserAnonymousCall(tokenDevice);
                }
              }
            }
          }
        })
        .catch((error) => {
          setGeneralError(true);
        });

       GetFares({ language: currentLanguage }).then((fares) => {
        if (fares.isSuccess) {
          dispatch(updateFares(fares.data));
          setFaresAPI(fares.data);
        }
      });

       GetAlerts({ language: currentLanguage }).then((alerts) => {
        if (alerts.isSuccess) {
          dispatch(updateAlerts(alerts.data));
          setWarningsAPI(alerts.data);
        }
      });

       GetContactData({ language: currentLanguage }).then((contact) => {
        if (contact.isSuccess) {
          dispatch(updateContactData(contact.data));
          setContactDataAPI(contact.data);
        }
      });

       GetEventsCategories(currentLanguage).then((categories) => {
        // dispatch(updateEventsCategory(EVENTS_CATEGORIES[currentLanguage]));
        if (categories.isSuccess) {
          categories.data.forEach((item) => dispatch(addEventsCategory(item)));
          setEventsCategoriesAPI(categories.data);
        }
      });

       GetFavorites().then((data) => {
        if (data.isSuccess) {
          dispatch(updateFavorites(data.data));
        }
        setFavoritesAPI(true);
      });

       GetLines().then((data) => {
        dispatch(updateLines(data.data));
        setLinesAPI(true);
      });

       getPriorityMessages(currentLanguage).then((data) => {
        dispatch(updatePriorityMessage(data.data));
      });

       GetCategoryFavorites(currentLanguage).then((categories) => {
        if (categories.isSuccess) {
          setCategoryFavoritesAPI(categories.data);
          if (categories.data && categories.data.length) {
            Promise.all(
              categories.data.map(async (category) => {
                const icon = await iconPresenter.getIcon(category.iconId); //GetIcons(category.iconId);
                return { ...category, icon: icon?.data };
              }),
            ).then((resolvedCategories) => {
              dispatch(updateCategoryFavorites(resolvedCategories));
            });
          }
        }
      });

       GetDataOrigin().then(async (dataOrigin) => {
         GetStops()
          .then((stopsData) => {
            formatMarkers(stopsData.data, dataOrigin.data, (stops: any) =>
              dispatch(updateStops(stops)),
            );
            setStopsAPI(true);
          })
          .catch((error) => {
            setGeneralError(true);
          });
        dispatch(updateDataOrigin(dataOrigin.data));
        setDataOriginAPI(true);
      });

      GetAgency().then((data) => {
        dispatch(updateAgencys(data.data));
        setAgencyAPI(true);
      });
      GetTransportMode().then((data) => {
        dispatch(updateTransportMode(data.data));
        setTranportModeAPI(true);
      });

      GetFaqKeywords({ language: currentLanguage }).then((keywords) => {
        if (keywords.isSuccess) {
          dispatch(updateFaqKeywordss(keywords.data));
        }
      });

      GetPoisCategories(currentLanguage)
        .then((data) => {
          dispatch(updateCategory(data.data));
          setPoisCategoriesAPI(data.data);
          return data.data;
        })
        .then(async (categories) => {
          //Obtenemos los iconos de las categorías de los pois
          if (categories && categories.length) {
            const poiIcons = await Promise.all(
              categories.map(async (category) => {
                const icon = await iconPresenter.getIcon(category.iconId); // GetIcons(category.iconId);
                return icon;
              }),
            );

            if (poiIcons && poiIcons.length) {
              dispatch(updatePoiCategoryIcons(poiIcons));
            }
            //OBTENEMOS y FILTRAMOS LOS POIS
            await GetPois(currentLanguage)
              .then((data) => {
                let poiData = data?.data || [];
                if (poiData.length > 0) {
                  poiData = poiData.map((poi) => {
                    const categoryData = categories?.find((c) => c.id === poi.poiCategoryId);
                    return {
                      ...poi,
                      data: {
                        iconPoiCategory: categoryData,
                      },
                    };
                  });
                }
                dispatch(updatePois(poiData));
                setPoisAPI(poiData);
                return poiData;
              })
              .then((pois) => {
                if (pois && pois.length) {
                  const filteredPointSalePois = pois.filter((poi) =>
                    POINTS_SALE_SECTIONS.includes(Number(poi?.data?.iconPoiCategory?.section)),
                  );
                  const filteredEmtOfficePois = pois.filter((poi) =>
                    PALMA_OFFICES_SECTIONS.includes(Number(poi?.data?.iconPoiCategory?.section)),
                  );
                  dispatch(updatePointsSalePois(filteredPointSalePois));
                  dispatch(updateEmtOfficePois(filteredEmtOfficePois));
                }
              });
          } //cierre if
        });
    } catch (error) {
      console.error(error);
    } finally {
      
    }
  };

  function checkIfExistUserAnon() {
    return (
      Object.keys(JSON.parse(localStorage.getItem('userAccountInformation') || '{}')).length > 0
    );
  }

  async function requestPermissionNotification() {
    let permission = await Notification.requestPermission();
    return permission;
  }

  async function obtainTokenFCM() {
    if (messaging) {
      const tokenDevice = await getToken(messaging, { vapidKey: process.env.API_GOOGLE_VAPID_KEY });
      return tokenDevice;
    }
  }

  async function createUserAnonymousCall(tokenDevice: string) {
    createUserAnonymous({
      ...userAccountInformation,
      tokenDevice: tokenDevice,
    }).then((response) => {
      if ('data' in response) {
        localStorage.setItem(
          'userAccountInformation',
          JSON.stringify({
            ...userAccountInformation,
            ...response.data,
            tokenDevice: tokenDevice,
          }),
        );
        //TODO: obtener idioma por defecto del usuario
        localStorage.setItem('userLanguage', DEFAULT_LANGUAGE);
        dispatch(updateUserData(response.data));
      }
    });
  }

  async function fillInformationUser() {
    try {
      const tokenDevice = await dispatch(userSliceFingerprint()).unwrap();

      if (checkIfExistUserAnon()) {
        dispatch(
          updateUserData(JSON.parse(localStorage.getItem('userAccountInformation') || '{}')),
        );
      } else {
        createUserAnonymousCall(tokenDevice);
      }
    } catch (error) {}
  }

  async function assignTokenFCM() {
    const tokenFCM = await obtainTokenFCM();
    if (tokenFCM && userAccountInformation.tokenDevice !== tokenFCM) {
      dispatch(tokenDeviceUpdate(tokenFCM));
      createUserAnonymousCall(tokenFCM);
    }
  }

  useEffect(() => {
    try {
      if (userAccountInformation.bearerToken) {
        precarga();
        requestPermissionNotification().then((permission) => {
          if (permission === 'granted') {
            assignTokenFCM();
          }
        });
      } else {
        fillInformationUser();
      }
    } catch (error) {}
  }, [userAccountInformation.bearerToken]);

  useEffect(() => {
    try {
      if (
        linesAPI !== null &&
        dataOriginAPI !== null &&
        //stopsAPI !== null &&
        agencyAPI !== null &&
        tranportModeAPI !== null 
        //poisAPI !== null &&
        //poisCategoriesAPI !== null
         /*&& favoritesAPI !== null &&  subscribeAPI !== null && accessAPI !== null*/
      ) {
        dispatch(updateShowLoading(false));
        setLoading(false);
        callback();
      }
    } catch (error) {}
  }, [
    faresAPI,
    menuFooterAPI,
    linesAPI,
    dataOriginAPI,
    stopsAPI,
    agencyAPI,
    tranportModeAPI,
    favoritesAPI,
    poisAPI,
    poisCategoriesAPI,
    warningsAPI,
    contactDataAPI,
    eventsCategoriesAPI,
    categoryFavoritesAPI,
  ]);

  return (
    <>
      {loading && <div style={{ minHeight: '100vh' }}>{getLoadingPage(location.pathname)}</div>}
      {generalError && <ErrorScreen errorCode={500} />}
    </>
  );
}
